<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="mr_code,mr_prodcode,mr_prodname"
      placeholder="输入维修单号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/make_repair/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.mr_prodcode }}</p>
          <p class="list-item-muted">{{ item.mr_code }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.mr_prodname }}</p>
          <span v-if="item.updaterName == null && item.mr_result == '不达标'"
            class="list-item-status warning"
            >待处理</span
          >
          <span v-else  class="list-item-status">已处理</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}条</label>
    </div>
    <add-button to="/production/make_repair_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/makeRepair/list",
      filters: [
        {
          type: "date",
          name: "make_repair.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待处理",
              condition: "make_repair.updaterName is null and qc_result = '不达标'",
            },
            {
              value: 2,
              label: "已处理",
              condition: "make_repair.updaterName is not null",
            },
          ],
        },
      ],
    };
  },
};
</script>